import type { UseQueryOptions, UseQueryResult } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { globalQueryClient } from 'queries/queryClient'
import type { ReportQueryProps, ReportResponseProps } from 'types/reports'

import { QUERIES } from '@/enums/queries'

import { getReports } from './services/loadReports'

export const useLoadReports = (
  params: ReportQueryProps,
  options: Omit<
    UseQueryOptions<
      ReportResponseProps,
      Error,
      ReportResponseProps,
      [string, ReportQueryProps]
    >,
    'queryKey' | 'queryFn'
  > = {}
): UseQueryResult<ReportResponseProps, Error> => {
  return useQuery({
    queryKey: [QUERIES.REPORTS.LIST, params],
    queryFn: ({ signal }) => getReports(params, { signal }),
    ...options,
  })
}

export const invalidateLoadReports = async () => {
  await globalQueryClient.invalidateQueries({
    queryKey: [QUERIES.REPORTS.LIST],
    exact: false,
  })
}
